module.exports = __webpack_public_path__ + "static/media/logo_alt.2e1d344a.png";